// lib/anmeldeZiel.js — Turnier-Bezug zwischen Turnierseite, Login und Registrierung (25.10.2026)
//
// Wer auf /event/:id „Jetzt anmelden“ drückt und noch nicht angemeldet ist,
// kommt nach /anmelden?turnier=<id>. Von dort zur Registrierung und zurück
// muss ?turnier= mitgehen (bis 25.10.2026 ging es beim Wechsel zu „Verein
// registrieren“ verloren), und nach Login bzw. Registrierung geht es direkt
// zur Anmeldung dieses Turniers im Vereinsbereich (/verein?turnier=<id>).
// Veranstaltungen (kein Turnier) gehen über ?event=<id>.
//
// Getestet: backend/utils/__tests__/anmeldeZiel.test.js (lädt diese Datei).

/** Zusatz ?turnier=…|?event=…[&name=…] für Links zwischen den Seiten. */
function zielZusatz({ turnier, event, name } = {}) {
  const p = new URLSearchParams();
  if (name) p.set('name', String(name));
  if (turnier) p.set('turnier', String(turnier));
  else if (event) p.set('event', String(event));
  const q = p.toString();
  return q ? `?${q}` : '';
}

/** Wohin nach erfolgreicher Vereinsanmeldung (Login oder frisch registriert)? */
function zielNachVereinsLogin({ turnier, event } = {}) {
  if (turnier) return `/verein?turnier=${encodeURIComponent(String(turnier))}`;
  if (event) return `/event-anmeldung/${encodeURIComponent(String(event))}`;
  return '/verein';
}

export { zielZusatz, zielNachVereinsLogin };
